import type { ReactNode } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'

import { delmanTerms } from '@/features/delman/delmanTerms'
import { getDelmanDevice } from '@/shared/auth/delmanDeviceStorage'
import { clearDelmanSession } from '@/shared/auth/delmanSessionStorage'
import { useClientHydrated } from '@/shared/hooks/useClientHydrated'

const nav = [
  { to: '/delman/trip', label: delmanTerms.modules.trip, icon: 'local_shipping' },
  { to: '/delman/material-return', label: delmanTerms.modules.materialReturn, icon: 'undo' },
] as const

export function DelmanShell({ children }: { children: ReactNode }) {
  const hydrated = useClientHydrated()
  const device = hydrated ? getDelmanDevice() : null
  const navigate = useNavigate()
  const { pathname } = useLocation()

  function handleLogout() {
    clearDelmanSession()
    navigate('/delman/login', { replace: true })
  }

  return (
    <div className="min-h-screen flex flex-col max-w-md mx-auto bg-surface">
      <header className="sticky top-0 z-10 bg-inverse-surface text-inverse-on-surface px-4 h-14 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <span className="material-symbols-outlined text-primary-container shrink-0">local_shipping</span>
          <div className="min-w-0">
            <p className="font-headline text-sm font-bold text-primary-container leading-tight">
              {delmanTerms.appName}
            </p>
            <p className="text-caption text-inverse-on-surface/60 truncate">
              {device ? device.delmanName : '—'}
            </p>
          </div>
        </div>
        <button
          type="button"
          onClick={handleLogout}
          className="text-xs text-inverse-on-surface/80 hover:text-inverse-on-surface whitespace-nowrap min-h-[44px]"
        >
          Keluar
        </button>
      </header>

      <main className="flex-1 p-4 pb-20">{children}</main>

      <nav className="fixed bottom-0 left-0 right-0 z-10 bg-surface-container-lowest border-t border-outline-variant safe-area-pb">
        <div className="max-w-md mx-auto flex justify-around px-2 py-1">
          {nav.map((item) => {
            const isActive = pathname === item.to || pathname.startsWith(`${item.to}/`)
            return (
              <Link
                key={item.to}
                to={item.to}
                className={`flex flex-col items-center gap-0.5 px-3 py-2 rounded-lg text-caption min-w-[60px] min-h-[44px] justify-center transition-colors ${
                  isActive ? 'text-primary font-bold bg-primary-container/30' : 'text-on-surface-variant'
                }`}
              >
                <span className="material-symbols-outlined text-[22px]">{item.icon}</span>
                {item.label}
              </Link>
            )
          })}
        </div>
      </nav>
    </div>
  )
}
